import { render, staticRenderFns } from "./Frases.vue?vue&type=template&id=f8ccba20"
import script from "./Frases.vue?vue&type=script&lang=js"
export * from "./Frases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports